import type { WorkOrder } from "./types";

export const hasTechnicalPending = (workOrder: Pick<WorkOrder, "operationalStatus" | "requiresReturn">) =>
  workOrder.requiresReturn || ["pending_completion", "incomplete"].includes(workOrder.operationalStatus);
